import gql from 'graphql-tag';

export default gql`
  query schoolOrDistrictRegistration($id: ID!) {
    schoolOrDistrictRegistration(id: $id) {
      ncesDistrictId
      setupProgress {
        isSiteLinked
        haveParentsBeenEmailed
        haveOrgsBeenEmailed
        haveStaffBeenTrained
        status
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/Onboarding/Setup/confirm/utils/schoolOrDistrictRegistration.query.js